'use client';

import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { usePathname } from 'next/navigation';

/**
 * Back-to-top pill. Mobile-only — desktop users have less scroll friction.
 * Appears after ~1000px scroll. Positioned bottom-left so it doesn't collide
 * with the other floating chrome on the right (cart bubble, compare, sticky buy).
 */
export function BackToTop() {
  const [visible, setVisible] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 1000);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Produktsidan har en fast köprad på mobil — en fjärde flytande knapp där blev
  // rörigt (ägaren 2026-10-02). Knappen är bara synlig på mobil (sm:hidden).
  if (pathname?.startsWith('/produkt/')) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Tillbaka till toppen"
      className={`fixed bottom-[calc(4.5rem_+_env(safe-area-inset-bottom))] left-3 sm:hidden z-30 h-11 w-11 inline-flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-md text-gray-700 active:scale-95 transition-all duration-200 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-2 pointer-events-none'
      }`}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
